import { useQuasar, LocalStorage } from "quasar";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { api } from "boot/axios";

import useMembership from "src/use/membership";
export default () => {
  const $store = useStore();
  const $router = useRouter();
  const $q = useQuasar();

  const { postReferralNumber } = useMembership();

  const sendOTP = async (countryCode, phoneNumber, recaptchaToken) => {
    try {
      const { data } = await api.post("/accounts/register/otp/", {
        country_code: countryCode,
        phone_number: phoneNumber,
        recaptcha_token: recaptchaToken,
      });

      if (data.is_firebase || !data.otp) return;

      $q.notify({
        type: "positive",
        message: `DEV: OTP code is ${data.otp}`,
      });
      return data.otp;
    } catch (error) {
      // let message = Object.values(error?.response?.data)?.[0];
      const { data } = error.response;

      const message = data
        ? data.phone_number
        : "incorrect mobile number or password";

      if (error?.response?.status === 500 && error?.response?.status === 403) {
        message = "Sending OTP timed out. Please retry";
      }
      if (!message) {
        message = "Error sending OTP";
      }
      if (error?.response?.status === 400) {
        $router.push({ name: "Login" });
      }

      $q.notify({
        type: "negative",
        message: message,
        timeout: 15000,
        textColor: "white",
        actions: [{ icon: "close", color: "white" }],
      });
    }
  };

  const verifyOTP = async (phoneNumber, otp) => {
    try {
      const response = await api.post("/accounts/register/otp/verify/", {
        phone_number: phoneNumber,
        otp: otp,
      });
      if (response.status === 204) return true;
    } catch (error) {
      console.error({ error });
      $q.notify({
        type: "negative",
        message: "Failed to verify OTP code",
      });
    }
    return false;
  };
  const sendOptForMultipleDiviceLogin = async (payload) => {
    const response = await api.post("/authenticate/v2/otp/send/", payload);
    return response;
  };
  const multipleDeviceVerifyOtp = async (token, otp) => {
    try {
      const response = await api.post("/authenticate/v2/verify/", {
        token: token,
        otp: otp,
      });
      if (response.status === 200) {
        let token = {
          access: response.data["access"],
          refresh: response.data["refresh"],
        };
        $store.commit("authenticate/setToken", token);
        LocalStorage.set("token", token);
        return true;
      }
    } catch (error) {
      console.error({ error });
      $q.notify({
        type: "negative",
        message: "Failed to verify OTP code",
      });
    }
    return false;
  };

  const signUp = async (phoneNumber, password1, password2, referrer = null) => {
    api
      .post("/accounts/register/", {
        phone_number: phoneNumber,
        password1: password1,
        password2: password2,
        medium: "chukul",
      })
      .then(({ data }) => {
        $store.commit("authenticate/setToken", data);
        $router.push({ name: "Dashboard" });
        LocalStorage.set("isSignup", true);
        if (referrer) {
          postReferralNumber(referrer);
          $q.notify({
            type: "positive",
            message: "Referral code applied",
          });
        }
        $q.notify({
          type: "positive",
          message: "Sign Up Successful",
        });
      })
      .catch((error) => {
        console.error({ error });

        let message = Object.values(error?.response?.data)?.[0];
        if (error?.response?.status === 500) {
          message = "Sign Up timed out. Please retry";
        }

        if (!message) {
          message = "Sign Up Failed";
        }

        $q.notify({
          type: "negative",
          message: message,
        });
      });
  };

  return {
    sendOTP,
    verifyOTP,
    multipleDeviceVerifyOtp,
    sendOptForMultipleDiviceLogin,
    signUp,
  };
};
